import * as z from "zod";
import { OC } from "../../utils";
import { AdminRole } from "./schema";

export const roleContract = OC.router({
  get: OC.meta({ permissions: true })
    .input(AdminRole.Get)
    .output(AdminRole.Role),
  getAll: OC.meta({ permissions: true }).output(z.array(AdminRole.Role)),
  create: OC.meta({
    alters: true,
    permissions: true,
    auditLog: { modelName: "ROLE", action: "CREATE" },
    aragon: "role_created",
  })
    .input(AdminRole.Create)
    .output(AdminRole.Role),
  update: OC.meta({
    alters: true,
    permissions: true,
    auditLog: { modelName: "ROLE", action: "UPDATE" },
    aragon: "role_updated",
  })
    .input(AdminRole.Update)
    .output(AdminRole.Role),
  delete: OC.meta({
    alters: true,
    permissions: true,
    auditLog: { modelName: "ROLE", action: "DELETE" },
    aragon: "role_deleted",
  })
    .input(AdminRole.Delete)
    .output(
      AdminRole.Role.omit({
        numberOfEmployees: true,
        numberOfPermissions: true,
      }),
    ),
});
